export default "__VITE_ASSET__015baeac__"